import { render, staticRenderFns } from "./TVPlayingLive.vue?vue&type=template&id=180611f0"
import script from "./TVPlayingLive.vue?vue&type=script&lang=ts"
export * from "./TVPlayingLive.vue?vue&type=script&lang=ts"
import style0 from "./TVPlayingLive.vue?vue&type=style&index=0&id=180611f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports